import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {FormGroup, Validators} from '@angular/forms';
import {EformService} from "../../../service/eform.service";

@Component({
   selector: 'app-radio',
   templateUrl: './radio.component.html',
   styleUrls: ['./radio.component.css']
})
export class RadioComponent implements OnInit {
   @Input() field: any = {};
   @Input() form: FormGroup;
   @Input() checkValidate: any;
   @Input() fieldName: any;
   @Input() labelName: any;
   @Input() choices: any;
   @Input() classes: any;
   @Input() isViewOnly: boolean;
   @Input() haveSign: boolean;
   @Input() hideHeader: boolean = false;
   choiceDefaultValue: string;
   value: any;
   choiceValue: any;

   constructor(private eformService: EformService, private cdr: ChangeDetectorRef) {
   }

   ngOnInit(): void {
      let eFormValue = this.eformService.eForm.value.value ? this.eformService.eForm.value.value[this.fieldName] : undefined;
      this.value = this.value ? this.value : eFormValue;
      if ((!this.value && this.value === undefined) && !this.field.choices) {
         if (this.field.radioDefaultValue && this.field.radioDefaultValue !== '') {
            this.value = this.field.radioDefaultValue === 'true' ? 0 : 1;
         }
      } else if ((!this.value && this.value === undefined) && this.field.choices) {
         if (this.field.choiceDefaultValue && this.field.choiceDefaultValue !== '') {
            this.choiceValue = this.field.choiceDefaultValue;
         }
      }
      this.setDefaultValue();
      if (this.choiceDefaultValue !== '' && !this.value) {
         this.form.controls[this.fieldName].setValue(this.choiceDefaultValue);
         this.choiceValue = this.choiceDefaultValue;
      } else if (this.field.fieldType !== 'f-radio' && this.field.fieldType !== 't-radio') {
         this.form.controls[this.fieldName].setValue(this.value ? this.value :'');
      }
   }

   setDefaultValue() {
      if (this.field.choiceOption === 0) {
         this.choiceDefaultValue = (this.field.choiceDefaultValue !== '-1') ?
            this.field.choiceDefaultValue.toString() : '';
      } else {
         this.choiceDefaultValue = (this.field.tempLookupDefault) ? this.field.tempLookupDefault.toString() : '';
      }

      if (this.value) {
         if (this.isEmpty(this.form.get(this.fieldName).value)) {
            if (this.form.get(this.fieldName)?.hasValidator(Validators.required)) {
               this.form.get(this.fieldName)?.setErrors({invalid: true})
               this.form.get(this.fieldName)?.updateValueAndValidity();
               this.form.get(this.fieldName)?.markAsDirty();
            }
            this.cdr.detectChanges();
         }
      }
   }

   isEmpty(value: any): boolean {
      return value == null || value === '' || value === '-1' || value === -1;
   }

}
